export default "__VITE_ASSET__647594ec__"